import { Checkbox, StyledFlex, StyledMargin } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { personnelTranslationKeys } from '../../../../translations';
import { AvailabilityFormController } from '../../common.types';

import { EncounterModeName } from './EncounterModeCheckboxes.types';

type EncounterModeCheckboxesProps = Pick<AvailabilityFormController, 'register' | 'watch'> & {
   name: EncounterModeName;
};

export const EncounterModeCheckboxes = (props: EncounterModeCheckboxesProps): JSX.Element => {
   const encounterMode = props.watch(props.name);

   return (
      <StyledMargin left={28}>
         <StyledFlex gap={8}>
            <span>
               <Translate>{personnelTranslationKeys.encounterModeLabel}</Translate>
               <span>{': '}</span>
            </span>
            <Checkbox
               label={personnelTranslationKeys.encounterModeMap.onSite}
               testId={`${props.name}.onSite`}
               controller={props.register(`${props.name}.onSite`)}
               disabled={!encounterMode?.videoConsultation}
               defaultValue={Boolean(true)}
            />
            <Checkbox
               label={personnelTranslationKeys.encounterModeMap.videoConsultation}
               testId={`${props.name}.videoConsultation`}
               controller={props.register(`${props.name}.videoConsultation`)}
               disabled={!encounterMode?.onSite}
               defaultValue={Boolean(true)}
            />
         </StyledFlex>
      </StyledMargin>
   );
};
